export default {
  state: () => ({
    events: [
      {
        start: "2022-02-22",
        image: "/BannerIncocegla.png",
        name: "blablabla",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor inci-didunt ut labore et dolore magna aliqua ut ut labore et dolore magna aliqua ut ut labore et dolore.",
      },
      {
        start: "2022-02-25",
        name: "blablabla",
        image: "/BannerIncocegla.png",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor inci-didunt ut labore et dolore magna aliqua ut ut labore et dolore magna aliqua ut ut labore et dolore.",
      },
      {
        start: "2022-02-28",
        name: "blablabla",
        image: "/BannerIncocegla.png",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor inci-didunt ut labore et dolore magna aliqua ut ut labore et dolore magna aliqua ut ut labore et dolore.",
      },
      {
        start: "2022-03-15",
        name: "blablabla",
        image: "/BannerIncocegla.png",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor inci-didunt ut labore et dolore magna aliqua ut ut labore et dolore magna aliqua ut ut labore et dolore.",
      },
    ],
  }),
  getters: {
    getEvents: (state) => state.events,
  },
  actions: {},
  mutations: {},
  namespaced: true,
};
